<script>
  import {mapActions, mapGetters} from 'vuex';
  import SpanTrueOrFalse from 'src/components/utils/SpanTrueOrFalse';
  import ChangePasswordDialogForm from './ChangePasswordDialogForm.vue';

  import RenderImagem from 'src/components/utils/RenderImagem'

  import apiService from 'src/services/ApiService';
  import utilsService from 'src/services/UtilsService';
  import utils from "../../utils";

  export default {
    components: {
      SpanTrueOrFalse,
      ChangePasswordDialogForm,
      RenderImagem
    },
    data() {
      return {
        instance: {
          name: '',
          username: '',
          email: '',
          phone: '',
          enabled: ''
        },
        changePasswordModal: false
      }
    },
    computed: {
      ...mapGetters([
        'loggedUser',
        'userLoggedRoles'
      ])
    },
    methods: {
      showChangePasswordModal: function () {
        this.changePasswordModal = true;
      },
      getLogo(id) {
        return utils.getUrlBusinessAreaImage(id);
      }
    },
    mounted: function () {
      //this.instance = this.loggedUser;

      this.instance.name = this.loggedUser.name;
      this.instance.username = this.loggedUser.username;
      this.instance.email = this.loggedUser.email;
      this.instance.phone = this.loggedUser.phone;
      this.instance.enabled = this.loggedUser.enabled;

      if (this.loggedUser.passwordExpired) {
        this.$alert(this.$t('yourPasswordIsExpired'), this.$t('passwordExpired'), {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
      }
    }
  }

</script>

<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <modulePanel>
          <div slot="body">
            <el-row>
              <el-col :span="24">
                <h4>{{ $t('user') }}</h4>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :md="6" :xs="24" :sm="6">
                <div class="icon-user text-align-center">
                  <i class="glyphicon glyphicon-user"></i>
                </div>
              </el-col>
              <el-col :md="18" :xs="24" :sm="18">
                <p id="name">
                  <b>{{ $t('name') + ':'}}</b>
                  {{instance.name}}
                </p>
                <p id="username">
                  <b>{{ $t('login') + ':'}}</b>
                  {{instance.username}}
                </p>
                <p id="phone">
                  <b>{{ $t('phone') + ':'}}</b>
                  {{instance.phone}}
                </p>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-button type="primary" size="small" @click.prevent="showChangePasswordModal()" id="changePassword">
                  {{$t("changePassword")}}
                </el-button>
              </el-col>
            </el-row>

            <ChangePasswordDialogForm
              v-model="changePasswordModal"
              v-if="changePasswordModal"
              :instance="instance"
            >
            </ChangePasswordDialogForm>

          </div>
        </modulePanel>
      </el-col>

      <el-col :span="12">
        <modulePanel>
          <div slot="body">
            <el-row>
              <el-col :span="24">
                <h4>{{ $t('businessLine') }}</h4>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div class="row display-initial">
                  <div v-for="row in loggedUser.businessLines" class="col-md-4 padding-top-10px">
                    <RenderImagem
                      height="height: 120px;"
                      :router="{ name: 'SystemsList', params: { businessAreaId: row.id } }"
                      :label="row.labelPt"
                      :src="getLogo(row.id)"
                    />
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </modulePanel>
      </el-col>
    </el-row>
  </div>
</template>
<style scoped>
  .display-initial {
    display: initial;
  }
  .text-align-center {
    text-align: center;
  }
  .icon-user {
    font-size: 80px;
    margin-top: 10px;
    margin-bottom: 0px;
    font-weight: 300;
    line-height: 1.1;
    color: #444;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .padding-top-10px{
    padding-top: 15px;
    padding-bottom: 15px;
  }
  @media (min-width: 1200px) {
    .col-lg-2 {
      width: 25% !important;
    }
    @media (min-width: 1400px) {
      .col-lg-2 {
        width: 16.66667% !important;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// UserProfile.vue?7130a3a6